import { DisclaimerBar } from './DisclaimerBar';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { investorsFeedbackModalStateSelector } from 'store/state/app/selectors';
import { setInvestorsFeedbackModalStateAction } from 'store/state/app/actions';

const mapStateToProps = (state: State) => ({
  modalState: investorsFeedbackModalStateSelector(state),
});

const mapDispatchToProps = {
  onModalState: setInvestorsFeedbackModalStateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisclaimerBar);
